import { doPost, toUrl } from "./lib.js";
import { receiveAnswer, receiveQuestionQuery } from "./schemas.js";
export async function askQuestion(clientInfo, input) {
  const url = toUrl(clientInfo.orgId, "ask/question");
  const json = await doPost(url, clientInfo, input);
  return receiveAnswer().parse(json);
}
export async function askForQuery(clientInfo, input) {
  const url = toUrl(clientInfo.orgId, "ask/query");
  const json = await doPost(url, clientInfo, input);
  return receiveQuestionQuery().parse(json);
}
export async function askForAnything(clientInfo, input) {
  const url = toUrl(clientInfo.orgId, "ask/anything");
  const json = await doPost(url, clientInfo, input);
  return receiveQuestionQuery().parse(json);
}
export async function askFeedback(clientInfo, input) {
  const url = toUrl(clientInfo.orgId, "ask/feedback");
  await doPost(url, clientInfo, input);
}
